import { useFormContext } from 'react-hook-form';
import { Button, DropdownItem, Highlight, Stack } from '@optimus-web/core';
import { lt, FormSelectField } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getEnterprises } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import { useCommanderSelector } from '@mews-commander/utils';
import { EnterpriseBuilderProFormFieldNames, EnterpriseBuilderProFormValues } from '../formMapping';
import { EnterpriseBuilderProFormStep } from '../../../types';

interface SourcePropertyStepProps {
    onStepChange: (step: EnterpriseBuilderProFormStep) => void;
}

export const ExportFromStep = ({ onStepChange }: SourcePropertyStepProps) => {
    const enterprises = useCommanderSelector((state) => getEnterprises(state));
    const { watch } = useFormContext<EnterpriseBuilderProFormValues>();
    const enterpriseId = watch(EnterpriseBuilderProFormFieldNames.EnterpriseId);

    return (
        <Stack vertical spacing="300">
            <Highlight size="medium">{lt('WhichPropertyExport')}</Highlight>
            <FormSelectField
                placeholder={TextKey.Search}
                virtualized
                name={EnterpriseBuilderProFormFieldNames.EnterpriseId}
                label={lt('Property')}
                required
                size="medium"
            >
                {Object.values(enterprises).map((enterprise) => (
                    <DropdownItem key={enterprise.id} value={enterprise.id} label={enterprise.name} />
                ))}
            </FormSelectField>
            <Stack alignment="end">
                <Button
                    variant="primary"
                    onClick={() => onStepChange(EnterpriseBuilderProFormStep.ImportTo)}
                    disabled={!enterpriseId}
                    type="submit"
                >
                    {lt('Next')}
                </Button>
            </Stack>
        </Stack>
    );
};
